import { useLanguage } from '../../contexts/LanguageContext'
import { EVENT_TYPES } from '../../lib/eventTypes'

// Emoji accents keyed by the canonical English event-type label.
const TYPE_EMOJI: Record<string, string> = {
  'Birthday Party': '🎂',
  Wedding: '💍',
  'Baby Shower': '🍼',
  'Corporate Event': '🥂',
  'Dinner Party': '🍽️',
  Anniversary: '💞',
  Graduation: '🎓',
  'Holiday Celebration': '🎄',
  'Charity Event': '🤝',
  Trip: '✈️',
  'Surprise Gift': '🎁',
  Other: '🎈',
}

const CHIP_TYPES = EVENT_TYPES.filter((t) => t.en !== 'Other')

// Infinite pure-CSS marquee on a dark ink band (mockup .marquee): big
// display-font event types, every other one dipped in the hot gradient. The
// track holds the item set twice (second copy aria-hidden) and slides -50%
// for a seamless loop.
const TrustMarquee = () => {
  const { language } = useLanguage()
  const isKa = language === 'ka'

  const chips = (hidden: boolean) => (
    <div className="flex shrink-0 items-center gap-10 pr-10" aria-hidden={hidden || undefined}>
      {CHIP_TYPES.map((t, i) => (
        <span
          key={t.en}
          className="inline-flex items-center gap-10 whitespace-nowrap font-display text-xl font-bold text-white sm:text-2xl"
        >
          <span className="inline-flex items-center gap-3">
            <span aria-hidden="true">{TYPE_EMOJI[t.en]}</span>
            <span className={i % 2 === 1 ? 'bg-grad-hot bg-clip-text text-transparent' : undefined}>
              {isKa ? t.ka : t.en}
            </span>
          </span>
          {/* Mockup .marquee .sep — amber four-pointed star between items. */}
          <span aria-hidden="true" className="text-celebration-amber">
            ✦
          </span>
        </span>
      ))}
    </div>
  )

  return (
    <section className="bg-celebration-ink py-7 dark:bg-[#1e1438]">
      <div className="landing-marquee">
        <div className="landing-marquee-track">
          {chips(false)}
          {chips(true)}
        </div>
      </div>
    </section>
  )
}

export default TrustMarquee
